<template>
  <v-container>
    <v-card class="elevation-15 rounded-lg">
      <v-card-title>
        <span class="text-h5">ค้นหานักศึกษา</span>
        <v-spacer class="mt-5"></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-row align="center" no-gutters>
          <v-col cols="12" md="2">
            <v-select
              v-model="searchOption"
              label="ตัวเลือกการค้นหา"
              :items="option"
              variant="outlined"
              item-title="text"
              item-value="value"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" class="ms-5">
            <v-text-field
              label="ค้นหา"
              variant="outlined"
              v-model="searchReq"
              append-inner-icon="mdi-account-search-outline"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" md="2" class="mb-6 ms-n5">
            <v-fade-transition>
              <v-btn
                prepend-icon="mdi-magnify-expand"
                color="blue-darken-2 elevation-15"
                @click="fetchStudents"
              >
                ค้นหา
              </v-btn>
            </v-fade-transition>
          </v-col>
          <v-col cols="12" md="2" class="mb-6 ms-n5">
            <v-fade-transition>
              <v-btn
                prepend-icon="mdi-magnify-expand"
                color="green-darken-2 elevation-15"
                @click="addStudentDialog = !addStudentDialog"
              >
                เพิ่มนักศึกษา
              </v-btn>
            </v-fade-transition>
          </v-col>
        </v-row>
      </v-card-text>

      <v-data-table
        v-if="students"
        :headers="headers"
        :items="students"
        :loading="loading"
        v-model:options="tableOptions"
        :server-items-length="students.length"
        style="font-size: 16px"
      >
        <template v-slot:loading>
          <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
        </template>

        <template v-slot:no-data>
          <v-alert type="info" class="ma-2"> กรอกข้อมูลนักศึกษาด้านบน </v-alert>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon size="small" @click="viewStudent(item)" color="primary">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
          <!-- <v-btn
            icon
            size="small"
            @click="editStudent(item)"
            color="warning"
            class="ml-1"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn> -->
        </template>

        <template v-slot:item.createdAt="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip :color="getStatusColor(item.status)" size="small">
            {{ item.status || "Active" }}
          </v-chip>
        </template>
      </v-data-table>
      <!-- <div class="d-flex justify-center my-4 align-center">
        <v-btn
          class="mx-2"
          :disabled="tableOptions.page === 1"
          @click="tableOptions.page--"
        >
          Previous
        </v-btn>

        <span class="text-h6 mx-4">
          {{ tableOptions.page }} of
          {{ Math.ceil(totalItems / tableOptions.itemsPerPage) }}
        </span>

        <v-btn
          class="mx-2"
          :disabled="
            tableOptions.page * tableOptions.itemsPerPage >= totalItems
          "
          @click="tableOptions.page++"
        >
          Next
        </v-btn>
      </div> -->
    </v-card>

    <v-dialog
      v-model="addStudentDialog"
      class="pa-1 ma-1 pb-1 mt-5 rounded-lg"
      width="100%"
      height="50vh"
      max-width="1100"
      transition="slide-y-transition"
      persistent
      elevation="15"
    >
      <v-card
        max-width="1300"
        prepend-icon="mdi-account-plus"
        rounded="lg"
        class="elevation-10 mb-5 p-0"
        title="เพิ่มนักศึกษาใหม่"
      >
        <v-row cols="12" justify="start">
          <v-col cols="12" md="12">
            <v-card-title class="ms-5">เลือกไฟล์ CSV</v-card-title>
            <v-spacer class="mt-5"></v-spacer>
            <v-card-text>
              <v-row justify="start" cols="12" class="ms-5">
                <v-col md="8" align-self="center" min-width="200">
                  <v-file-input
                    variant="outlined"
                    v-model="file"
                    label="Select CSV File"
                    hint="ตรวจสอบข้อมูลไฟล์กับทางสำนักงานคณบดีก่อนส่ง"
                    accept=".csv"
                    outlined
                    prepend-icon="mdi-file-upload"
                    hint-color="red"
                  ></v-file-input>
                </v-col>
              </v-row>
              <v-spacer class="mt-0"></v-spacer>
            </v-card-text>
          </v-col>
        </v-row>

        <template v-slot:actions>
          <v-btn
            v-if="file"
            class="mb-3 mr-3"
            variant="elevated"
            elevation="3"
            color="green-darken-2"
            text="บันทึก"
            @click="confirmupload()"
          ></v-btn>

          <v-btn
            class="mb-3 mr-3"
            variant="elevated"
            elevation="3"
            color="red"
            text="ปิด"
            @click="(addStudentDialog = false), (file = null)"
          ></v-btn>
        </template>
      </v-card>
    </v-dialog>

    <!-- <v-dialog
      v-if="authStore.user"
      v-model="authStore.editAccount"
      width="80%"
      height="85vh"
      max-width="1300"
      class="py-2"
      transition="slide-y-transition"
      persistent
    >
      <v-card
        max-width="1300"
        prepend-icon="mdi-account-plus"
        rounded="lg"
        class="elevation-10 mb-5 p-0"
        title="แก้ไขข้อมูล"
      >
        <v-card-text>
          <v-container class="py-2">
            <v-row justify="start" align="start">
              <v-col cols="12" md="3">
                <v-text-field
                  label="รหัสนักศึกษา"
                  variant="outlined"
                  class=""
                  v-model="authStore.user.studentNum"
                  readonly
                  width="100%"
                  hint="ไม่อนุญาติให้แก้ไข"
                  color="red"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="start" align="center">
              <v-col cols="12" md="4" sm="12">
                <v-text-field
                  label="ชื่อ-นามสกุล"
                  variant="outlined"
                  class=""
                  v-model="authStore.user.displayName"
                  readonly
                  width="100%"
                  hint="ไม่อนุญาติให้แก้ไข"
                  color="red"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-text-field
                  label="email"
                  variant="outlined"
                  class=""
                  v-model="authStore.user.email"
                  readonly
                  width="70%"
                  hint="ไม่อนุญาติให้แก้ไข"
                  color="red"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12" md="2" xs="12">
                <v-btn
                  v-if="isEditing"
                  class="mb-5"
                  variant="elevated"
                  elevation="3"
                  color="blue-darken-3"
                  :text="isChangingPassword ? 'ยกเลิก' : 'เปลี่ยนรหัสผ่าน'"
                  :disabled="!isEditing"
                  @click="isChangingPassword = !isChangingPassword"
                  width="100%"
                ></v-btn>
              </v-col>
              <v-col cols="12" md="3" v-show="isChangingPassword">
                <v-text-field
                  @click:append-inner="showPassword = !showPassword"
                  :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  label="รหัสผ่านใหม่"
                  variant="outlined"
                  class="mb-auto"
                  v-model="reqPassword"
                  :disabled="!isEditing"
                  width="100%"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" v-show="isChangingPassword">
                <v-text-field
                  @click:append-inner="showPasswordCon = !showPasswordCon"
                  :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPasswordCon ? 'text' : 'password'"
                  label="ยืนยันรหัสผ่านใหม่"
                  variant="outlined"
                  class="mb-auto"
                  v-model="reqPasswordCon"
                  :disabled="!isEditing"
                  width="100%"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" v-show="isChangingPassword">
                <v-text-field
                  @click:append-inner="showOldPass = !showOldPass"
                  :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showOldPass ? 'text' : 'password'"
                  label="รหัสผ่านเก่า"
                  variant="outlined"
                  class="mb-auto"
                  v-model="reqOldPassword"
                  :disabled="!isEditing"
                  width="100%"
                  @blur="showConfirm = true"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="1" v-show="isChangingPassword">
                <v-btn
                  class="mb-5"
                  variant="elevated"
                  elevation="3"
                  color="green-darken-3"
                  text="ยืนยัน"
                  :disabled="!isEditing"
                  @click="checkpassword()"
                  width="50%"
                ></v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <template v-slot:actions>
          <v-btn
            v-if="!isEditing"
            class="mb-3 mr-3"
            variant="elevated"
            elevation="3"
            color="amber-darken-1"
            text="แก้ไขข้อมูล"
            @click="isEditing = true"
          ></v-btn>

          <v-btn
            class="mb-3 mr-3"
            variant="elevated"
            elevation="3"
            color="red"
            text="ปิด"
            @click="
              (isEditing = false),
                (isChangingPassword = false),
                (authStore.editAccount = false),
                clearinput()
            "
          ></v-btn>
        </template>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="detailDialog" max-width="70vw">
      <v-card v-if="selectedStudent">
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" size="x-large" class="mr-3"
            >mdi-account-circle</v-icon
          >
          <div class="text-h5 font-weight-bold">ข้อมูลนักศึกษา</div>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-row class="mb-6" cols="12" md="12">
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-icon color="indigo" class="mr-2">mdi-numeric</v-icon>
              <div>
                <div class="text-subtitle-2 text-medium-emphasis">
                  Student ID
                </div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ selectedStudent.studentNum }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-icon color="indigo" class="mr-2">mdi-account</v-icon>
              <div>
                <div class="text-subtitle-2 text-medium-emphasis">Name</div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ selectedStudent.displayName }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-icon color="indigo" class="mr-2">mdi-email</v-icon>
              <div>
                <div class="text-subtitle-2 text-medium-emphasis">Email</div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ selectedStudent.email }}
                </div>
              </div>
            </v-col>
          </v-row>

          <v-expansion-panels>
            <v-row
              justify="start"
              class="mt-6"
              v-if="authStore.user && selectedStudent.PLO"
            >
              <v-col cols="12" md="12" sm="12">
                <v-card elevation="10">
                  <v-card-title class="bg-pink white--text d-flex align-center">
                    <v-icon class="mr-2" color="white">mdi-chart-line</v-icon>
                    ผลการเรียน PLO (Program Learning Outcomes)
                  </v-card-title>
                  <v-card-text class="pa-4">
                    <v-expansion-panels variant="inset" multiple flat>
                      <v-expansion-panel
                        v-for="(yearData, yearKey) in selectedStudent.PLO"
                        :key="yearKey"
                      >
                        <v-expansion-panel-title
                          class="text-h6 font-weight-medium"
                        >
                          <div class="d-flex align-center w-100">
                            <v-icon class="mr-3" color="primary"
                              >mdi-calendar-range</v-icon
                            >
                            <div class="flex-grow-1">
                              <div class="text-subtitle-1 font-weight-bold">
                                ปีการศึกษา {{ yearKey }}
                              </div>
                              <div class="text-caption text-medium-emphasis">
                                คลิกเพื่อดูรายละเอียด
                              </div>
                            </div>
                          </div>
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                          <v-expansion-panels variant="inset" multiple flat>
                            <v-expansion-panel
                              v-for="(ploData, ploKey) in yearData"
                              :key="ploKey"
                            >
                              <v-expansion-panel-title
                                class="text-h6 font-weight-medium"
                              >
                                <div class="d-flex align-center w-100">
                                  <v-icon class="mr-3" color="primary">
                                    {{
                                      /* FIXED: Changed "PL0" (with a zero) 
                                    to "PLO" (with an "O") 
                                  */
                                      `mdi-numeric-${parseInt(
                                        ploKey.replace("PLO", ""),
                                      )}-circle`
                                    }}
                                  </v-icon>
                                  <div class="flex-grow-1">
                                    <div
                                      class="text-subtitle-1 font-weight-bold"
                                    >
                                      {{ ploKey }}
                                    </div>
                                    <div
                                      class="text-caption text-medium-emphasis"
                                    >
                                      คลิกเพื่อดูรายละเอียด
                                    </div>
                                  </div>
                                </div>
                              </v-expansion-panel-title>

                              <v-expansion-panel-text class="pa-0">
                                <div v-if="'Score' in ploData" class="pa-4">
                                  <div
                                    class="text-subtitle-1 font-weight-medium"
                                  >
                                    Score:
                                  </div>
                                  <div
                                    class="text-h5 text-primary font-weight-bold"
                                  >
                                    {{ ploData.Score }}
                                  </div>
                                </div>

                                <v-list v-else dense>
                                  <v-list-item
                                    v-for="(score, subjectKey) in ploData"
                                    :key="subjectKey"
                                  >
                                    <v-list-item-title
                                      class="font-weight-medium"
                                      >{{ subjectKey }}</v-list-item-title
                                    >
                                    <v-list-item-subtitle
                                      >Score: {{ score }}</v-list-item-subtitle
                                    >
                                  </v-list-item>
                                </v-list>
                              </v-expansion-panel-text>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row
              justify="start"
              class="mt-6"
              v-if="authStore.user && hasAcademicResults"
            >
              <v-col cols="12" md="12" sm="12">
                <v-card elevation="10">
                  <v-card-title
                    class="bg-indigo white--text d-flex align-center"
                  >
                    <v-icon class="mr-2" color="white">mdi-chart-line</v-icon>
                    ผลการเรียน ( Academic Result )
                  </v-card-title>

                  <v-card-text class="pa-4">
                    <v-expansion-panels variant="inset" multiple>
                      <v-expansion-panel
                        v-for="(
                          yearData, yearKey
                        ) in selectedStudent.Academic_results"
                        :key="yearKey"
                      >
                        <v-expansion-panel-title
                          class="text-h6 font-weight-medium"
                        >
                          <div class="d-flex align-center w-100">
                            <v-icon class="mr-3" color="primary"
                              >mdi-calendar-range</v-icon
                            >
                            <div class="flex-grow-1">
                              <div class="text-subtitle-1 font-weight-bold">
                                {{ yearKey }}
                              </div>
                              <div
                                class="text-caption text-medium-emphasis opacity-75"
                              >
                                คลิกเพื่อดูรายละเอียด
                              </div>
                            </div>
                          </div>
                        </v-expansion-panel-title>

                        <v-expansion-panel-text>
                          <v-expansion-panels variant="inset" multiple>
                            <v-expansion-panel
                              v-for="(Score, ploKey) in yearData"
                              :key="ploKey"
                            >
                              <v-expansion-panel-title
                                class="text-h6 font-weight-medium"
                              >
                                <div class="d-flex align-center w-100">
                                  <v-icon class="mr-3" color="primary">
                                    {{
                                      `mdi-numeric-${parseInt(
                                        ploKey.replace("PL0", ""),
                                      )}-circle`
                                    }}
                                  </v-icon>
                                  <div class="flex-grow-1">
                                    <div
                                      class="text-subtitle-1 font-weight-bold"
                                    >
                                      {{ ploKey }}
                                    </div>
                                    <div
                                      class="text-caption text-medium-emphasis opacity-75"
                                    >
                                      คลิกเพื่อดูคะแนน
                                    </div>
                                  </div>
                                  <div class="mr-4"></div>
                                </div>
                              </v-expansion-panel-title>

                              <v-expansion-panel-text>
                                <v-row>
                                  <v-col cols="12" md="6">
                                    <div class="mb-4">
                                      <div class="d-flex align-center mb-3">
                                        <span
                                          class="font-weight-bold text-subtitle-1"
                                          >คะแนน : {{ Score }}</span
                                        >
                                      </div>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-text>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :text="
              selectedStudent.isDefaultPassword
                ? 'เป็นรหัสผ่าน default'
                : 'รีเซ็ตรหัสผ่าน'
            "
            variant="elevated"
            color="orange-darken-1 elevation-2"
            @click="handleResetPassword(selectedStudent)"
            class="mb-3 mr-3 font-weight-bold"
          >
          </v-btn>
          <v-btn
            variant="elevated"
            color="red-darken-1 elevation-2"
            @click="detailDialog = false"
            class="mb-3 mr-3 font-weight-bold"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script setup>
import { ref, onMounted, watch, computed } from "vue";
import { useAuthStore } from "@/stores/auth";
const { proxy } = getCurrentInstance();

import { getCurrentInstance } from "vue";
const authStore = useAuthStore();
import axios from "axios";
const API_BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL;
const searchOption = ref("studentNum");
const option = ref([
  { text: "รหัสนักศึกษา", value: "studentNum" },
  { text: "ชื่อ-นามสกุล นักศึกษา", value: "displayName" },
]);
const students = ref([]);
const loading = ref(false);
const searchReq = ref("");
const searchTimeoutId = ref(null);
const totalItems = ref(0);
const detailDialog = ref(false);
const selectedStudent = ref(null);
const addStudentDialog = ref(null);
const file = ref(null);
const confirmCSV = ref(false);
watch(searchReq, (newValue) => {
  // Clear the previous timeout if it exists
  if (searchTimeoutId.value) {
    clearTimeout(searchTimeoutId.value);
  }

  // Set a new timeout to call fetchStudents after a delay
  searchTimeoutId.value = setTimeout(() => {
    // Only call the API if the input has a value
    if (newValue) {
      fetchStudents();
    }
  }, 500); // Wait 1000ms (1 second) after the last keypress
});
// Centralize all table state in one object

const hasAcademicResults = computed(() => {
  // 1. Check if selectedStudent and its Academic_results even exist
  if (!selectedStudent.value || !selectedStudent.value.Academic_results) {
    return false;
  }

  // 2. Access the results using .value
  const results = selectedStudent.value.Academic_results;

  // 3. Filter out the default keys
  const dataKeys = Object.keys(results).filter(
    (key) => key !== "createdAt" && key !== "updatedAt",
  );

  // 4. Return true if any other keys exist
  return dataKeys.length > 0;
});

const tableOptions = ref({
  page: 1,
  itemsPerPage: 10,
  sortBy: [],
  sortDesc: [],
  multiSort: false,
  search: "",
  searchType: "displayName", // <-- Add search property here
});
const TOKEN = authStore.getBackendJwt();
// Table headers configuration
const headers = ref([
  { title: "Student ID", key: "studentNum", sortable: false },
  { title: "Name", key: "displayName", sortable: false },
  { title: "Actions", key: "actions", sortable: false, width: "350px" },
]);

// Fetch students from API
const fetchStudents = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/api/profile`, {
      params: {
        search: searchReq.value, // <-- Use the new centralized search property
        searchType: searchOption.value,
      },
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
      },

      validateStatus: function (status) {
        return (
          (status >= 200 && status < 300) ||
          status === 400 ||
          status === 403 ||
          status === 401
        );
      },
    });

    const data = response.data;
    students.value = data.student;
    totalItems.value = data.totalStudents;
    console.log(students.value);

    if (response.status === 403) {
      await proxy.$swal({
        title: "Error!",
        text: response.data?.message || "Invalid Operation",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    } else if (response.status === 401) {
      await proxy.$swal({
        title: "Error!",
        text: response.data?.message || "Invalid Operation",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    }

    // totalItems.value = data.totalItems;
  } catch (error) {
    console.error("Error fetching students:", error);

    students.value = [];
    // totalItems.value = 0;
  } finally {
    loading.value = false;
  }
};
let fetchTimeout = null;

// watch(
//   () => [
//     tableOptions.value.page,
//     tableOptions.value.itemsPerPage,
//     tableOptions.value.search,
//     tableOptions.value.searchType,
//     searchOption.value,
//   ],
//   async (newValues, oldValues) => {
//     // Check if the page or items per page changed
//     const paginationChanged =
//       newValues[0] !== oldValues[0] || newValues[1] !== oldValues[1];

//     // Check if the search term or type changed
//     const searchChanged =
//       newValues[2] !== oldValues[2] || newValues[3] !== oldValues[3];

//     // Reset page to 1 only if the search criteria changed
//     if (searchChanged) {
//       tableOptions.value.page = 1;
//     }

//     // Debounce the API call
//     if (fetchTimeout) {
//       clearTimeout(fetchTimeout);
//     }

//     fetchTimeout = setTimeout(() => {
//       fetchStudents();
//     }, 500);
//   },
//   { deep: true }
// );

// On mount, make the initial fetch
// onMounted(() => {
//   fetchStudents();
// });
// Action handlers
const viewStudent = (student) => {
  selectedStudent.value = student;
  detailDialog.value = true;
};
// Utility functions
const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case "active":
      return "success";
    case "inactive":
      return "error";
    case "pending":
      return "warning";
    default:
      return "success";
  }
};

const confirmupload = () => {
  proxy
    .$swal({
      title: `คุณมั่นใจในการอัปโหลดข้อมูล ใช่หรือไม่?`,
      showDenyButton: true,
      confirmButtonText: "ยืนยัน",
      denyButtonText: `ยกเลืก`,
      customClass: {
        container: "my-swal-container", // Apply a custom class to the main SweetAlert container
      },
    })
    .then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        fileupload();
      } else if (result.isDenied) {
        return;
      }
    });
};

const fileupload = async () => {
  if (!file.value) {
    proxy.$swal({
      title: "เกิดข้อผิดพลาด",
      text: ` NO file selected`,
      icon: "error",
      timer: 2000,
      customClass: {
        container: "my-swal-container", // Apply a custom class to the main SweetAlert container
      },
    });
    return;
  }
  try {
    authStore.loading = true;
    const formData = new FormData();
    formData.append("file", file.value);
    const response = await axios.post(
      `/api/AddStudentCSV`,
      formData,

      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${TOKEN}`,
        },

        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 401 ||
            status === 403
          );
        },
      },
    );
    if (response.status === 200) {
      proxy.$swal({
        title: "อัปโหลดสำเร็จ!",
        text: "Upload CSV file successfully!! ",
        icon: "success",
        timer: 2000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
      file.value = null; // Reset the file input after successful upload
      confirmCSV.value = false;
      confirmCSV.value = false;
    } else if (response.status === 500) {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` ${response.data.message}`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    } else if (response.status === 401 || response.status === 403) {
      router.push("/");
    } else {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` An unexpected error occurred.`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    alert("Error processing file. Check the console for details.");
  } finally {
    authStore.loading = false;
  }
};

const handleResetPassword = async (student) => {
  try {
    authStore.loading = true;
    const response = await axios.patch(
      `/api/reset-password`,
      { studentNum: student.studentNum },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },

        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 401 ||
            status === 403 ||
            status === 404
          );
        },
      },
    );
    if (response.status === 200) {
      proxy.$swal({
        title: "รีเซ็ตรหัสผ่านสำเร็จ!",
        text: `รหัสผ่านใหม่คือ ${response.data.defaultPassword}PTU `,
        icon: "success",
        timer: 5000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    } else if (response.status === 400) {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` ${response.data.message}`,
        icon: "error",
        timer: 5000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    } else if (response.status === 401 || response.status === 403) {
      router.push("/");
    } else {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` An unexpected error occurred.`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    }
  } catch (error) {
    console.error("Error resetting password:", error);
    alert("Error processing request. Check the console for details.");
  } finally {
    authStore.loading = false;
    fetchStudents(); // Refresh the student list to reflect any changes
  }
};
</script>
<style scoped>
.v-data-table {
  min-height: 400px;
}

.v-skeleton-loader {
  margin: 16px;
}
</style>
